import React from 'react';
import { Unsubscribe as UnsubscribeScreen } from '@features/unsubscribe';

export const Unsubscribe = (props: any) => <UnsubscribeScreen {...props} />;
